import Cookies from 'js-cookie';
import { formatListMessages, parseJson } from './HtmlHelper';
import { loginPage } from 'constants/defaultValues';
import { setCurrentUser } from './Utils';

const buildJsonOptions = (method, params) => {
   return {
      method: method, // 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'include', //'same-origin', // include, *same-origin, omit
      crossDomain: true,
      headers:
         params instanceof FormData
            ? {
                 //'Content-Type': 'multipart/form-data',
                 'X-CSRF-TOKEN': Cookies.get('csrf_access_token'),
              }
            : {
                 'Content-Type': 'application/json',
                 Accept: 'application/json',
                 'X-CSRF-TOKEN': Cookies.get('csrf_access_token'),
              },
      // redirect: 'follow', // manual, *follow, error
      // referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body:
         params instanceof FormData
            ? params
            : params
            ? JSON.stringify(params)
            : null, // body data type must match "Content-Type" header
   };
};

const postData = async (url = '', data = {}) => {
   try {
      const response = await fetch(url, {
         method: 'POST',
         headers: {
            'Content-Type': 'application/json',
         },
         body: JSON.stringify(data), // convert JS object to JSON string
      });

      if (!response.ok) {
         // If HTTP response status is not OK (200–299)
         const errorData = await response.json();
         return { success: false, error: errorData };
      }

      const result = await response.json();
      return { success: true, data: result }; // success response
   } catch (error) {
      // Handle network errors (like no internet, server unreachable)
      return { success: false, error: error.message };
   }
};

let _apiUrl = '';

const setApiUrl = (url) => (_apiUrl = url);

const getApiUrl = () => {
   return _apiUrl ?? '';
};

const mapUrl = (endpoint) => {
   if (endpoint === undefined) return '';
   if (endpoint?.startsWith('http')) return endpoint;
   const apiUrl = _apiUrl;
   const url = apiUrl + (apiUrl.endsWith('/') ? '' : '/') + endpoint;
   return url;
};

const getParamStr = (params) => {
   if (!params) return '';
   const ret = [];
   for (var p in params) {
      ret.push(`${p}=${params[p]}`);
   }
   return ret.join('&');
};

const fetchx = async (
   method,
   endpoint,
   params = null,
   skipRedirectLogin = false
) => {
   const options = buildJsonOptions(method, params);
   try {
      let fullUrl = mapUrl(endpoint);
      if (method == 'GET' && params)
         fullUrl += (fullUrl.includes('?') ? '&' : '?') + getParamStr(params);
      const response = await fetch(fullUrl, options);

      if (response.ok) {
         let data = {};
         try {
            data = await response?.json(); // this would raise error i.e. Delete method
         } catch {}
         return { data: data, ok: response?.ok, code: response?.status };
      }
      const msg = await checkResponseAsync(
         response,
         () => {
            //console.log("Repeating calling " + endpoint)
            return fetchx(method, endpoint, params, skipRedirectLogin);
         },
         skipRedirectLogin
      );
      if (msg?.ok) {
         return {
            data: msg?.data,
            ok: msg?.ok,
            code: msg?.code,
         };
      }

      let message = null;

      // check if response has a body

      const contentType = response.headers.get('content-type');

      if (contentType?.includes('application/json')) {
         try {
            message = await response.json();
         } catch (e) {
            message = null;
         }
      }

      if (message) {
         return {
            data: message?.message ?? msg?.data ?? msg,
            ok: false,
            code: response?.status ?? msg?.code,
         };
      } else {
         return {
            data: response?.statusText ?? msg?.statusText,
            ok: false,
            code: response?.status ?? msg?.status,
         };
      }
   } catch (ex) {
      console.log(ex);
      return errorCatcher(ex);
   }
};

const fetchx2 = async (method, endpoint, params = null) => {
   const options = buildJsonOptions(method, params);
   try {
      let fullUrl = mapUrl(endpoint);
      if (method == 'GET' && params)
         fullUrl += (fullUrl.includes('?') ? '&' : '?') + getParamStr(params);

      const response = await fetch(fullUrl, options);
      if (response.ok) {
         let data = {};
         try {
            data = await response.json(); // this would raise error i.e. Delete method
         } catch {}
         return { data: data, ok: response.ok, code: response.status };
      }

      return {
         data: await response.json(),
         ok: false,
         code: response.status,
      };

      // let message = null;

      // // check if response has a body

      // const contentType = response.headers.get('content-type');

      // if (contentType?.includes('application/json')) {
      //    try {
      //       message = await response.json();
      //    } catch (e) {
      //       message = null;
      //    }
      // }

      // if (message) {
      //    return {
      //       data: message?.message,
      //       ok: false,
      //       code: response?.status,
      //    };
      // } else {
      //    return {
      //       data: response?.statusText,
      //       ok: false,
      //       code: response?.status,
      //    };
      // }
   } catch (ex) {
      console.log(ex);
      return errorCatcher(ex);
   }
};

const errorCatcher = (ex) => {
   console.log(ex);
   let errMsg = ex.message;
   if (errMsg == 'Failed to fetch')
      errMsg = `Could not connect to API server. Please try again later.`;
   return {
      data: errMsg,
      ok: false,
      code: 500,
   };
};

const getBlob = async (endpoint) => {
   const options = buildJsonOptions('GET', null);
   try {
      const url = mapUrl(endpoint);
      const response = await fetch(url, options);
      if (response.ok) {
         const data = await response.blob();
         return { data: data, ok: response.ok, code: response.status };
      }
      const msg = await checkResponseAsync(response, () => {
         return getBlob(endpoint);
      });
      return { data: await msg?.json(), ok: false, code: response.status };
   } catch (ex) {
      return errorCatcher(ex);
   }
};

const get = async (endpoint, params = null) => {
   return fetchx('GET', endpoint, params);
};

const tryGet = async (endpoint, params = null) => {
   return await fetchx('GET', endpoint, params, true);
};

const post = async (endpoint, params) => {
   return fetchx('POST', endpoint, params);
};
const postBlob = async (endpoint, params) => {
   const options = buildJsonOptions('POST', params);
   try {
      const response = await fetch(mapUrl(endpoint), options);
      if (response.ok) {
         const data = await response.blob();
         return { data: data, ok: response.ok, code: response.status };
      }
      const msg = await checkResponseAsync(response, () => {
         return postBlob(endpoint, params);
      });

      console.log(msg);

      return { data: await msg?.json(), ok: false, code: response.status };
   } catch (ex) {
      return errorCatcher(ex);
   }
};
const put = async (endpoint, params) => {
   return fetchx('PUT', endpoint, params);
};

const postOrPut = async (endpoint, editingId, params) => {
   if (editingId) {
      const url =
         endpoint + (endpoint.endsWith('/') ? editingId : '/' + editingId);
      return put(url, params);
   }
   return post(endpoint, params);
};

const deletex = async (endpoint) => {
   return fetchx('DELETE', endpoint);
};

const deleteWithBody = async (endpoint, params) => {
   return fetchx('DELETE', endpoint, params);
};
const postLogin = async (endpoint, params) => {
   return await fetchx2('POST', endpoint, params);
};

let isRefreshing = false;
let refreshSubscribers = [];

function subscribeTokenRefresh(callback) {
   refreshSubscribers.push(callback);
}

function onRefreshed() {
   refreshSubscribers.forEach((callback) => callback('refresh-success'));
   refreshSubscribers = [];
}

function onRefreshFailed() {
   refreshSubscribers.forEach((callback) => callback('refresh-failed'));
   refreshSubscribers = [];
}

function safeRedirectToLogin() {
   const alreadyRedirected = localStorage.getItem('redirectedToLogin');
   const isLoginPage = window.location.pathname.includes('/login');
   if (!alreadyRedirected && !isLoginPage) {
      localStorage.setItem('redirectedToLogin', true);
      localStorage.setItem(
         'SavedUrl',
         JSON.stringify(window.location.pathname)
      );
      window.location.href = loginPage;
   }
}

const checkResponseAsync = async (
   response,
   onAuthRefreshed,
   skipRedirectLogin = false
) => {
   if (response.status === 429) {
      const customMsg = await response?.text();
      return (
         customMsg?.replace(/^"|"$/g, '') ||
         'Access limit reached. Hold on until next 15 seconds.'
      );
   }

   if (response.status === 401 && !skipRedirectLogin) {
      const waitForRefresh = new Promise((resolve) => {
         subscribeTokenRefresh(async (status) => {
            if (status === 'refresh-failed') {
               setCurrentUser(null);
               safeRedirectToLogin();
               resolve('Unauthorized');
            } else if (status === 'refresh-success') {
               const result = onAuthRefreshed ? await onAuthRefreshed() : null;
               resolve({
                  data: result?.data,
                  code: result?.code,
                  ok: result?.ok,
               });
            }
         });
      });

      const timeout = new Promise((resolve) => {
         setTimeout(() => {
            if (isRefreshing) {
               isRefreshing = false;
               onRefreshFailed();
               setCurrentUser(null);
               safeRedirectToLogin();
               resolve('Unauthorized');
            }
         }, 5000); // 10 seconds
      });

      if (!isRefreshing) {
         isRefreshing = true;
         try {
            const refreshRes = await post('V2/auth/refresh', {});
            if (refreshRes.ok) {
               setCurrentUser(refreshRes.data);
               isRefreshing = false;
               onRefreshed();
            } else {
               isRefreshing = false;
               onRefreshFailed();
               setCurrentUser(null);
               safeRedirectToLogin();
            }
         } catch (err) {
            isRefreshing = false;
            onRefreshFailed();
            setCurrentUser(null);
            safeRedirectToLogin();
         }
      }

      return Promise.race([waitForRefresh, timeout]);
   }
   return response;
};

const stringifyError = (err) => {
   let msg = '';
   if (err?.errors) {
      //&& errJson.type?.includes("https://tools.ietf.org/html/")) {
      msg = formatListMessages(`${err.status}: ${err.title}`, err.errors);
   } else if (err?.message) msg = err.message;
   else msg = JSON.stringify(err);
   return msg;
};

const apix = {
   get,
   post,
   put,
   postOrPut,
   deletex,
   deleteWithBody,
   getBlob,
   postBlob,
   postLogin,
   tryGet,
   getApiUrl,
   setApiUrl,
};
export default apix;
